'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@petsmart-ui/sparky';
import { useRouter } from 'next/navigation';
import { type MouseEvent } from 'react';
import { useShallow } from 'zustand/shallow';
import { trackClickContinueShopping } from '@libs/analytics';
import { useCartConfirmDrawer } from './model/useCartConfirmDrawer';
export const Footer = t0 => {
  const $ = _c(18);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onCloseAll
  } = t1;
  const router = useRouter();
  const {
    close,
    content
  } = useCartConfirmDrawer(useShallow(_temp));
  let t2;
  if ($[2] !== close || $[3] !== content.secondaryAction || $[4] !== onCloseAll) {
    t2 = () => {
      trackClickContinueShopping();
      content.secondaryAction?.onClick?.();
      close();
      onCloseAll?.();
    };
    $[2] = close;
    $[3] = content.secondaryAction;
    $[4] = onCloseAll;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleContinueShopping = t2;
  let t3;
  if ($[6] !== content.primaryAction || $[7] !== router) {
    t3 = event => {
      event.preventDefault();
      content.primaryAction?.onClick?.();
      router.push(content.primaryAction?.href ?? "/cart");
    };
    $[6] = content.primaryAction;
    $[7] = router;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handlePrimaryAction = t3;
  const t4 = content.secondaryAction?.text ?? "Continue shopping";
  let t5;
  if ($[9] !== handleContinueShopping || $[10] !== t4) {
    t5 = <Button fullWidth={true} type="button" text={t4} onClick={handleContinueShopping} />;
    $[9] = handleContinueShopping;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = content.primaryAction?.text ?? "View cart and checkout";
  let t7;
  if ($[12] !== handlePrimaryAction || $[13] !== t6) {
    t7 = <Button fullWidth={true} type="button" variant="primary" onClick={handlePrimaryAction} text={t6} />;
    $[12] = handlePrimaryAction;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
function _temp(store) {
  return {
    close: store.close,
    content: store.content
  };
}